<template>
	<b-card>
		<div class="hidden-print">
			<b-row class="m-2">
				<b-col>
					<multiselect :options="departments" v-model="departmentId" label="name" track-by="id" :multiple="false" :allow-empty="true" :group-select="true" :show-labels="false"  class="multiselect-pricing" :placeholder="$t('promo-to-product.department')"/>
				</b-col>
				<b-col>
					<date-picker v-model="startDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker v-model="endDate" lang="ru" style="width: 100%" :placeholder="$t('по (время)')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
			</b-row>
			<b-row class="m-2">
				<b-col>
					<multiselect v-model="currency" :options="options"  class="multiselect-pricing" :placeholder="$t('Валюта')"/>
				</b-col>
				<b-col>
						<multiselect v-model="expanseTypeId" :options="Why" label="why" track-by="id" @search-change="" :allow-empty="true" :multiple="false" :group-select="true" :show-labels="false" class="multiselect-pricing" :placeholder="$t('Тип Расходы')"/>
				</b-col>
				<b-col cols="1" align="center">
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-3"/>
				</b-col>
			</b-row>
		</div>
		<b-card-body>
			<b-overlay :show="loading" rounded opacity="0.7">
				<b-table :items="items" :fields="columns" striped hover show-empty :busy="loading" class="m-2 mr-2" id="gridContainer" >
					<template slot="id" slot-scope="data">
						{{(data.index + 1) }}
					</template>
					<template #foot(id)="data">
						{{""}}
					</template>
					<template #foot(departmentName)="data">
						{{""}}
					</template>
					<template #foot(expanseDate)="data">
						{{""}}
					</template>
					<template #foot(currencyCode)="data">
						{{""}}
					</template>
					<template #foot(amount)="data">
						{{""}}
					</template>
					<template #foot(comment)="data">
						{{""}}
					</template>
				</b-table>
			</b-overlay>
			<b-row class="m-2">
				<b-col v-if="item.summaUSZ">
					<b>Итого USZ: </b> <span>{{item.summaUSZ}} UZS</span>
				</b-col>
				<b-col v-if="item.summaUSD">
					<b>Итого USD: </b> <span>{{item.summaUSD}} USD</span>
				</b-col>
			</b-row>
			<b-button v-if="items.length > 0" class="float-right mt-1" @click="excelExport1('gridContainer', 'Отчет Расходов')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import DxDataGrid, {DxColumn, DxExport, DxColumnChooser, DxFilterRow, DxSearchPanel, DxLoadPanel} from "devextreme-vue/data-grid";
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import {BTable, VBTable} from "bootstrap-vue";
import ReportService from "./report.service";
import { BOverlay } from 'bootstrap-vue';
import ReferencesService from "../../../services/references.sevice";
export default {
	name: "Index",
	components: {
		BOverlay,
		Multiselect,
		BTable,
		VBTable
	},
	data() {
		return {
			payload: {
				page: 1,
				limit: 20,
				value: "",
			},
			item:[],
			columns : [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'departmentName', label: this.$t('promo-to-product.department'), class: 'text-center', sortable: true},
				{key: 'expanseDate', label: this.$t('Дата'), sortable: true, class: 'text-center'},
				{key: 'currencyCode', label: this.$t('Валюта'), class: 'text-center'},
				{key: 'amount', label: this.$t('Сумма'), class: 'text-center'},
				{key: 'comment', label: this.$t('комментария'), class: 'text-center'},
			],
			expanseTypeId:'',
			currency:"",
			options:['UZS','USD'],
			startDate:"",
			endDate:'',
			departmentId: null,
			departmentIds: null,
			loading:false,
			Why:[],
			items:[],
			departments:[],
		}
	},
	watch: {
	},
	methods: {
		onContentReady(e) {
			e.component.option("loadPanel.enabled", false);
		},
		getDepartments() {
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getItems() {
			this.loading = true
			if (this.departmentId && this.startDate  && this.endDate) {
				let data = {
					departmentId: this.departmentId ? this.departmentId.id : null,
					startDate: this.startDate,
					endDate: this.endDate,
					currency: this.currency,
					expanseTypeId: this.expanseTypeId.id,
				}
				ReportService.getReportItems7(data).then(res => {
					this.items = res.data.expanses
					this.item = res.data
					this.loading = false
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					this.loading = false
				})
			}
			else {
				this.$vs.notify({
					title: "Выберите Подразделение с периодом",
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			}
		},
		print() {
			window.print();
		},
		listItems(search){
			if (search === ''){
				search = null
			}
			ReferencesService.getSearchExpenses2(search).then(res => {
				this.Why = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			var dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		}
	},
	created() {
		this.getDepartments()
		this.listItems('')
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}
</style>
